import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import BenefitsManagement from '../components/BenefitsManagement';

const AdminBenefitsPlansPage = ({ dashboardHomePath = '/admin', scope = 'tenant' }) => {
  const navigate = useNavigate();
  const isGlobalScope = scope === 'global';
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold">Benefit Plans</h2>
          <p className="text-sm text-muted-foreground">
            {isGlobalScope
              ? 'The plans every new workspace starts with. Editing these does not change a workspace already using them — people are enrolled in those.'
              : 'Dedicated page for benefit plan management.'}
          </p>
        </div>
        <Button variant="outline" onClick={() => navigate(dashboardHomePath)}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
      </div>
      <BenefitsManagement currentTab="plans" hiddenTabs={['my-benefits', 'enrollment']} scope={scope} />
    </div>
  );
};

export default AdminBenefitsPlansPage;
